import { gql } from '@apollo/client';

export const UPDATE_RFID_TAG_NAME = gql`
  mutation UpdateRfidTagName($input: UpdateRfidTagNameInput!) {
    updateRfidTagName(input: $input) {
      serialNumber
      name
      customerUid
    }
  }
`;
